import { makeAutoObservable } from 'mobx'
import CheckableMap from 'src/models/CheckableMap'

import { FavoriteProblemTree } from '../Problem/FavoriteProblemTree'

export class FavoriteTreeColl {
  constructor(
    private treeMap: CheckableMap<FavoriteProblemTree['curriculumId'], FavoriteProblemTree>
  ) {
    makeAutoObservable(this)
  }

  get toArr() {
    return [...this.treeMap.values()]
  }

  get entries() {
    return this.treeMap.entries()
  }

  get isEmpty() {
    return this.treeMap.isEmpty
  }

  get isNotEmpty() {
    return this.treeMap.isNotEmpty
  }

  values() {
    return this.treeMap.values()
  }

  set(k, v) {
    return this.treeMap.set(k, v)
  }

  has(k) {
    return this.treeMap.has(k)
  }

  delete(id: FavoriteProblemTree['curriculumId']) {
    return this.treeMap.delete(id)
  }

  checkSize() {
    return this.treeMap.checkSize
  }

  toCheckedValues() {
    return this.treeMap.toCheckedValues
  }

  toCheckedSize() {
    return this.treeMap.toCheckedValues.length
  }

  get(k) {
    return this.treeMap.get(k)
  }

  setCheck(v: FavoriteProblemTree['curriculumId']) {
    this.treeMap.setCheck(v)
  }

  clearAllCheck() {
    this.treeMap.clearAllCheck()
  }
  isChecked(v: FavoriteProblemTree['curriculumId']) {
    return this.treeMap.isChecked(v)
  }
  get isPartChecked() {
    return this.treeMap.isPartChecked
  }
  toggleCheck(v: FavoriteProblemTree['curriculumId']) {
    this.treeMap.toggleCheck(v)
  }

  adds(treeColl) {
    this.treeMap.adds(treeColl.treeMap.entries())
  }
}
